

const TruckAndCrewWarningModal = ({

    open,
    onClose,
    onConfirm,


}) => {

    const visible = typeof open === 'boolean' ? open : !!open
    if (!visible) return null
    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#7876A1]/50 font-instrument">
            {/* Main modal container */}
            <div
                role="dialog"
                aria-modal="true"
                aria-label="Book one mover warning"
                className="relative rounded-2xl overflow-hidden font-instrument flex flex-col items-center justify-center px-[15px] pb-[15px]"
                style={{
                    width: 328,
                    background: '#F6F6F6',
                    borderRadius: '16px',
                    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)'
                }}
            >
                {/* Close button top-left */}
                <div className="flex justify-start items-start w-full pt-[16px] cursor-pointer">
                    <img
                        onClick={onClose}
                        src="/Vision Agent Icons/X Icon/XLightpurple.svg" alt="close" />
                </div>


                {/* Title and icon container */}
                <div className="flex flex-col items-center gap-2 mt-[20px]">
                    {/* Attention icon container */}
                    <div className="h-16 w-16 rounded-full bg-[#C8C6DF] flex justify-center items-center">


                        <div className="relative w-[43px] h-[43px] flex items-center justify-center">
                            <img
                                src="/images/NewUiIcons/Polygon4.svg"
                                alt="decorative polygon"
                                className="absolute inset-0 w-full h-full"
                            />
                            <img
                                src="/images/NewUiIcons/AttentionIcon.png"
                                alt="attention"
                                className="relative w-[22px] h-[22px] z-10 mt-1"
                            />
                        </div>
                    </div>
                    <h2 className="text-[24px] font-semibold text-[#34318C] leading-tight">
                        Are you sure?
                    </h2>

                </div>

                <div className="flex flex-col px-3">

                    <p className="mt-[18px] text-[13px] text-[#34318C] w-full font-normal leading-[120%] text-start">
                        Changing the <strong>truck</strong> or <strong>number of movers</strong> may impact loading time and fit. If it's too
                        small, you may need a second trip.
                        Continue with your changes?
                    </p>


                    <p className="mt-[18px] text-[13px] text-[#34318C] w-full font-normal leading-[120%] text-start">
                        Questions? Call (825) 305-5300.
                    </p>
                </div>





                {/* Buttons container */}
                <div className="flex w-full justify-center mt-[16px] gap-2">
                    <button
                        onClick={() => {

                            onClose && onClose()

                        }}
                        className="flex-1 w-[145px] bg-[#C8C6DF] text-[#34318C] h-[48px] rounded-[15px] font-semibold text-[14px] hover:bg-[#d0cce8] focus:outline-none transition-colors"
                        aria-label="Keep 2 movers"
                    >
                        Cancel
                    </button>

                    <button
                        onClick={() => {
                            onConfirm && onConfirm()
                            onClose && onClose()
                        }}
                        className="flex-1 w-[145px] bg-[#34318C] text-white h-[48px] rounded-[15px] leading-[14px] font-semibold text-[14px] hover:bg-[#2a276b] focus:outline-none transition-colors"
                        aria-label="Book 1 mover anyway"
                    >
                        Confirm changes
                    </button>
                </div>
            </div>
        </div>
    )
}

export default TruckAndCrewWarningModal